import { handleActions } from 'redux-actions'
import * as actions from './actions'

const defaultState = { selectedNoteId: null, createdNoteId: null }

export default handleActions(
  {
    [actions.selectNote]: (state, { payload: noteId }) => ({
      ...state,
      selectedNoteId: noteId
    }),
    [actions.createNoteSuccess]: (state, { payload: noteId }) => ({
      ...state,
      createdNoteId: noteId
    }),
    [actions.resetCreatedNoteId]: state => ({
      ...state,
      createdNoteId: null
    }),
    [actions.deleteNoteSuccess]: (state, { payload: noteId }) => ({
      ...state,
      deletedNoteId: noteId
    }),
    [actions.resetDeletedNoteId]: state => ({
      ...state,
      deletedNoteId: null
    })
  },
  defaultState
)



// WEBPACK FOOTER //
// ./src/services/note/reducer.js